import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Shield, Lock, CheckCircle } from 'lucide-react';

export const SecurePayment = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gradient-to-b from-purple-50 to-white" data-testid="secure-payment-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
              <Shield className="h-8 w-8 text-purple-600" />
            </div>
          </div>
          <h2 className="text-3xl font-bold mb-4">{t('securePayment')}</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('securePaymentDesc')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          <Card className="text-center">
            <CardContent className="pt-6">
              <Lock className="h-10 w-10 text-purple-600 mx-auto mb-4" />
              <h3 className="font-semibold mb-2">SSL Şifreleme</h3>
              <p className="text-sm text-gray-600">256-bit SSL sertifikası ile korumalı</p>
            </CardContent>
          </Card>

          <Card className="text-center">
            <CardContent className="pt-6">
              <CheckCircle className="h-10 w-10 text-purple-600 mx-auto mb-4" />
              <h3 className="font-semibold mb-2">PCI-DSS Uyumlu</h3>
              <p className="text-sm text-gray-600">Uluslararası güvenlik standartları</p>
            </CardContent>
          </Card>

          <Card className="text-center">
            <CardContent className="pt-6">
              <Shield className="h-10 w-10 text-purple-600 mx-auto mb-4" />
              <h3 className="font-semibold mb-2">iyzico Garantisi</h3>
              <p className="text-sm text-gray-600">Türkiye'nin güvenilir ödeme platformu</p>
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-8">
          <img 
            src="/iyzico-logo-pack/checkout_iyzico_ile_ode/TR/Tr_Colored_Horizontal/iyzico_ile_ode_colored_horizontal.svg" 
            alt="iyzico" 
            className="h-8 mx-auto opacity-60"
          />
        </div>
      </div>
    </section>
  );
};
